module.exports = __webpack_public_path__ + "img/9788957980262.e9fb2d5a.jpg";